<template>
  <v-btn
    :title="buttonEnabled ? options.tooltipHideText : options.tooltipShowText"
    icon
    small
    v-show="show"
    @click="emitToggleEvent"
  >
    <v-icon small :color="iconColor" dark>{{ options.icon }}</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "FilterTitleButton",
  data: () => {
    return {
      buttonEnabled: false,
    };
  },
  computed: {
    iconColor: function() {
      return this.buttonEnabled ? "primary" : "";
    },
  },
  props: {
    options: Object,
    show: Boolean,
  },
  methods: {
    emitToggleEvent: function() {
      if (this.options.toggle) {
        this.buttonEnabled = !this.buttonEnabled;
      }
      this.$emit("toggle", this.options.clickEventName);
    },
  },
};
</script>

<style></style>
